import React, { useEffect, useState } from "react";
import { AiOutlineDelete } from "react-icons/ai";
import { server } from "../../../common";
import { toast } from "react-toastify";
import { AxiosError } from "axios";
import { useSelectAccess } from "../../../store/stateFunctions";
import { NavLink } from "react-router-dom";
import useQuickLook from "../../../quicklook/useQuickLook";

const IdeasFromStudent = () => {
  const user = useSelectAccess("Industry User");
  const [data, setData] = useState([]);
  const displayFile = useQuickLook();

  useEffect(() => {
    getData();
  }, []);

  const getData = () => {
    server
      .get("/ideas/getallinnovative_ideas", {
        headers: {
          "Content-Type": "application/json",
          Authorization: user.authToken,
        },
      })
      .then(function (response) {
        console.log("api response", response.data);
        if (response.status === 200 || response.status === 201) {
          setData(response.data);
        }
      })
      .catch(function (error) {
        if (error instanceof AxiosError && error.response?.data?.message)
          toast.error(error.response.data.message);
        else if (error.response?.data?.error) {
          toast.error(error.response.data.error);
        } else toast.error("Failed to connect to server");
      });
  };

  return (
    <>
      <h3 className="my-4 text-center">Innovative Ideas From Student</h3>
      <div className="container" style={{ overflowXX: "scroll" }}>
        <table class="table table-striped border">
          <thead>
            <tr>
              <th scope="col">Sr. No.</th>
              <th scope="col">Student Name</th>
              <th scope="col">Email Id</th>
              <th scope="col">Problem Statement</th>
              <th scope="col">Solution</th>
            </tr>
          </thead>
          <tbody>
            {data &&
              data?.map((item, index) => {
                return (
                  <tr key={item.id}>
                    <th scope="row">{index + 1}</th>
                    <td>{item.fullname}</td>
                    <td>{item.contactno}</td>
                    <td>{item.problem_statement}</td>
                    <td>{item.idea}</td>

                    {/* <td>
                    <NavLink
                      className="banner text-white p-2 rounded-3"
                      to="/industryprofile/positions-internship"
                    >
                      View
                    </NavLink>
                  </td> */}
                    {/* <td>
                    <div className="btn banner text-white">
                      <AiFillEdit onClick={() => handleShowEdit(item)} />
                    </div>
                  </td>
                  <td>
                    <div className="btn banner text-white">
                      <AiFillDelete onClick={() => handleDelete(item)} />
                    </div>
                  </td> */}
                  </tr>
                );
              })}
          </tbody>
        </table>
      </div>
    </>
  );
};

export default IdeasFromStudent;
